import { selectAssignment } from '@redux/experiments/selectors/index';
import type { StorefrontPeaceOfMindAssignment } from '@typings/experiments';
import type { State } from 'types/redux';

export const storefrontPeaceOfMindSelector = (state: State) => {
	const isPom = state.vendor.vendor?.settings.peaceOfMindEligible;

	if (!isPom) {
		return null;
	}

	return selectAssignment(state, [
		'storefrontPeaceOfMind',
	]) as StorefrontPeaceOfMindAssignment;
};
